
<div
  tabindex="0"
  :data-id="objectModelAction.client_id"
  :data-type="objectModelAction.action_type"
  class="form-element"
  :class="propertyClasses"
  @focus="replaceIdInRoute"
  @click.stop="replaceIdInRoute">
  <row class="title-bar">
    <column>
      <strong>{{ObjectModelActionDefinition.getDisplayName(objectModelAction.action_type)}}</strong>
    </column>
    <suffix v-if="isMoveDestroyable">
      <move-destroy
        :card="objectModelAction"
        @remove:card="remove"
        class="suffix"
      ></move-destroy>
    </suffix>
    <suffix v-else>
      <icon class="locked"></icon>
      <span class="sr-only">Action Locked</span>
    </suffix>
  </row>
  <row>
    <column class="row-title" v-if="objectModelAction.can(ObjectModelActionCapability.labelable)">
      <object-model-action-labelable
        :object-model-action="objectModelAction"></object-model-action-labelable>
    </column>
  </row>

  <component
    :is="getComponentByType(objectModelAction.action_type)"
    :object-model-action="objectModelAction"
    @remove="remove"></component>
</div>
